import { dataURLToBlob } from "blob-util";
import Restful from "lib/restful";

const uploadImage = async (type, imageDataURL, idToken) => {
  const imageBlob = dataURLToBlob(imageDataURL);
  const getUrlFn =
    type === "outfit"
      ? Restful.getUrlForOutfitUploadAPI
      : type === "item"
      ? Restful.getUrlForItemUploadAPI
      : type === "profile"
      ? Restful.getUrlForProfileUploadAPI
      : () => {};

  return new Promise(async (resolve, reject) => {
    const image = new File([imageBlob], "upload.jpg", { type: "image/jpeg" });

    const { code, res, errInfo } = await getUrlFn({ idToken });
    if (code === "error") {
      const errObj = Error("api error");
      errObj.errorValue = { ...errInfo };
      reject(errObj);
    }
    const { url, file } = res;

    const { code: code2, errInfo: errInfo2 } = await Restful.uploadImageToS3({
      url,
      image
    });
    if (code2 === "error") {
      const errObj = Error("api error");
      errObj.errorValue = { ...errInfo2 };
      reject(errObj);
    }

    resolve(file);
  });
};

export { uploadImage };
